import type { TargetAndTransition, Transition } from 'framer-motion';
import {
  CONTROLS_ANIMATION,
  type HeroCarouselControlsAnimationEventHandler,
  HeroCarouselControlsAnimationEvent,
} from './Cherocarouselcontrols.constants';

interface NotifyHeroCarouselControlsAnimationEventInput {
  onAnimationEvent?: HeroCarouselControlsAnimationEventHandler;
  eventName: HeroCarouselControlsAnimationEvent;
}

interface ResolveHeroCarouselControlsTransitionInput {
  shouldShowControls: boolean;
  controlsEntranceDelay: number;
}

interface ResolveArrowControlsAnimationInput {
  shouldShowControls: boolean;
  hiddenX: number;
}

interface ResolveControlsVisibilityAnimationInput {
  shouldShowControls: boolean;
}

export function notifyHeroCarouselControlsAnimationEvent({
  onAnimationEvent,
  eventName,
}: NotifyHeroCarouselControlsAnimationEventInput): void {
  if (!onAnimationEvent) {
    return;
  }

  onAnimationEvent(eventName);
}

export function resolveHeroCarouselControlsTransition({
  shouldShowControls,
  controlsEntranceDelay,
}: ResolveHeroCarouselControlsTransitionInput): Transition {
  return {
    duration: shouldShowControls ? CONTROLS_ANIMATION.duration : 0,
    ease: CONTROLS_ANIMATION.ease,
    delay: shouldShowControls ? controlsEntranceDelay : 0,
  };
}

export function resolveHeroCarouselControlsOpacityAnimation({
  shouldShowControls,
}: ResolveControlsVisibilityAnimationInput): TargetAndTransition {
  return {
    opacity: shouldShowControls ? 1 : 0,
  };
}

export function resolveHeroCarouselControlsArrowAnimation({
  shouldShowControls,
  hiddenX,
}: ResolveArrowControlsAnimationInput): TargetAndTransition {
  return {
    ...resolveHeroCarouselControlsOpacityAnimation({ shouldShowControls }),
    x: shouldShowControls ? 0 : hiddenX,
  };
}

/** The ghost row (Build Your Own • Quick Start) drops in from above. */
export function resolveHeroCarouselControlsBuildQuickStartRowAnimation({
  shouldShowControls,
}: ResolveControlsVisibilityAnimationInput): TargetAndTransition {
  return {
    ...resolveHeroCarouselControlsOpacityAnimation({ shouldShowControls }),
    y: shouldShowControls ? 0 : -CONTROLS_ANIMATION.buildYourOwnDistance,
  };
}
